const InlineArrayEditor = ({
  items = [],
  onChange,
  fieldConfig = [],
  addButtonLabel = "Add Item",
  minItems = 0,
}) => {
  const handleAdd = () => {
    const newItem = {};
    fieldConfig.forEach((field) => {
      newItem[field.name] = "";
    });
    onChange([...items, newItem]);
  };

  const handleRemove = (index) => {
    if (items.length > minItems) {
      const newItems = items.filter((_, i) => i !== index);
      onChange(newItems);
    }
  };

  const handleItemFieldChange = (index, fieldName, value) => {
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      [fieldName]: value,
    };
    onChange(newItems);
  };

  return (
    <div className="space-y-3">
      {items.map((item, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg p-4 bg-gray-50"
        >
          <div className="flex justify-between items-center mb-3">
            <span className="text-sm font-semibold text-gray-700">
              Item {index + 1}
            </span>
            {items.length > minItems && (
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="text-red-600 hover:text-red-800 text-sm font-medium transition-colors"
              >
                Remove
              </button>
            )}
          </div>

          <div className="space-y-3">
            {fieldConfig.map((field) => (
              <div key={field.name}>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {field.label || field.name}
                </label>
                {field.type === "textarea" ? (
                  <textarea
                    value={item[field.name] || ""}
                    onChange={(e) =>
                      handleItemFieldChange(index, field.name, e.target.value)
                    }
                    rows={field.rows || 3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={field.placeholder || ""}
                  />
                ) : (
                  <input
                    type={field.type || "text"}
                    value={item[field.name] || ""}
                    onChange={(e) =>
                      handleItemFieldChange(index, field.name, e.target.value)
                    }
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={field.placeholder || ""}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={handleAdd}
        className="w-full py-2 px-4 border border-gray-300 rounded-md bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors"
      >
        + {addButtonLabel}
      </button>
    </div>
  );
};

export default InlineArrayEditor